// Chakra imports
import {
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  FormLabel,
  Input,
  useToast,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import TablesCategoryRow from "components/Tables/TablesCategoryRow";
import React, { useState } from "react";
import categorieService from "../../../../api/categories/categories";

const Categorie = ({ title, captions, data }) => {
  const textColor = useColorModeValue("gray.700", "white");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const initialRef = React.useRef();
  const finalRef = React.useRef();

  const [categoryName, setCategoryName] = useState(""); // État pour le nom de la catégorie
  const [loading, setLoading] = useState(false); // État pour l'indicateur de chargement

  const handleSubmit = async () => {
    if (!categoryName.trim()) {
      toast({
        title: "Erreur",
        description: "Le nom de la catégorie est obligatoire.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      setLoading(true); // Activer l'indicateur de chargement
      const newCategory = { name: categoryName }; // Données pour l'API
      const response = await categorieService.createCategorie(newCategory); // Appel au service API
      toast({
        title: "Succès",
        description: "La catégorie a été créée avec succès.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      // Optionnel : Mettre à jour localement la liste des catégories
      data.push({
        id: response.id,
        name: response.name,
        createdAt: response.createdAt,
      });

      setCategoryName(""); // Réinitialiser le formulaire
      onClose(); // Fermer la modal
    } catch (error) {
      toast({
        title: "Erreur",
        description:
          error.response?.data?.message || "Une erreur est survenue.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      console.log(error)
    } finally {
      setLoading(false); // Désactiver l'indicateur de chargement
    }
  };

  return (
    <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
      <CardHeader p="6px 0px 22px 0px">
        <Flex direction="row" gap={5}>
          <Text fontSize="xl" color={textColor} fontWeight="bold">
            {title}
          </Text>
          <Button
            w="50%"
            p="8px 32px"
            me="8px"
            colorScheme="orange"
            borderColor="#e2aa23"
            color="#e2aa23"
            variant="outline"
            fontSize="xs"
            onClick={onOpen}
          >
            Ajouter
          </Button>
          <Modal
            initialFocusRef={initialRef}
            finalFocusRef={finalRef}
            isOpen={isOpen}
            onClose={onClose}
          >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Créer une Catégorie</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <FormControl>
                  <FormLabel>Nom de la catégorie</FormLabel>
                  <Input
                    ref={initialRef}
                    placeholder="Nom de la catégorie"
                    value={categoryName}
                    onChange={(e) => setCategoryName(e.target.value)} // Mettre à jour l'état
                  />
                </FormControl>
              </ModalBody>

              <ModalFooter>
                <Button
                  colorScheme="orange"
                  mr={3}
                  onClick={handleSubmit}
                  isLoading={loading} // Indicateur de chargement
                >
                  Créer
                </Button>
                <Button onClick={onClose}>Annuler</Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </Flex>
      </CardHeader>
      <CardBody>
        <Table variant="simple" color={textColor}>
          <Thead>
            <Tr my=".8rem" pl="0px" color="gray.400">
              {captions.map((caption, idx) => (
                <Th color="gray.400" key={idx} ps={idx === 0 ? "0px" : null}>
                  {caption}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {data.map((row) => (
              <TablesCategoryRow
                key={`${row.id}-${row.name}`}
                id={row.id}
                name={row.name}
                createdAt={new Date(row.createdAt).toLocaleDateString("fr-FR", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              />
            ))}
          </Tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default Categorie;
